import { useEffect } from 'react'

import {
  getLocalStorageAndStaleStatus,
  setLocalStorage,
  setStoreUI,
} from '@utsubo/ui'
import { getUser, useUserStore } from '@utsubo/experience'

const fetchUserWorkspacesList = async () => {
  const { user } = getUser()
  const userId = user.uid
  const local = getLocalStorageAndStaleStatus(
    `workspaces-list-${userId}`,
    60 * 20
  )

  if (local?.data) {
    setStoreUI({ allWorkspaces: local.data })

    if (!local?.stale) {
      // if data is still new then we don't need to fetch it again
      return
    }
  }

  const idToken = await user.getIdToken()

  const resp = await fetch(`/api/user/get-workspaces`, {
    method: 'POST',
    body: JSON.stringify({}),

    headers: {
      authorization: `Bearer ${idToken}`,
    },
  })

  const { workspaces, success } = await resp.json()
  if (success) {
    setStoreUI({
      allWorkspaces: workspaces,
    })

    setLocalStorage(`workspaces-list-${userId}`, workspaces)
  }
}

const FirestoreUserWorkspacesListFetch = () => {
  const mainUserId = useUserStore((s) => s.id)
  useEffect(() => {
    if (mainUserId === 'tempId') return

    fetchUserWorkspacesList()
  }, [mainUserId])

  return null
}

export { FirestoreUserWorkspacesListFetch }
